import { ServerDetails } from "@gymflow/api";
import { createContext } from "react";

export const ApiResolverContext = createContext<ServerDetails>({} as any);
